module.exports = __webpack_public_path__ + "img/77279.7ebe64e9.svg";